import { useState, useEffect } from "react";
import { Modal, Button, TextInput, Textarea } from "@mantine/core";
import { createExpense, updateExpense } from "../../services/expenses"; // Import your expense services

const ExpenseManager = ({
  isOpen,
  onClose,
  expenseData,
  userId,
  getExpensesMethod,
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (expenseData) {
      setTitle(expenseData.title);
      setDescription(expenseData.description);
      setAmount(expenseData.amount);
    } else {
      setTitle("");
      setDescription("");
      setAmount("");
    }
  }, [expenseData]);

  const handleSave = async () => {
    setLoading(true);
    try {
      if (expenseData) {
        await updateExpense({
          _id: expenseData._id,
          amount,
          date: new Date(),
          productStockId: expenseData.productStockId,
          productStockQuantity: expenseData.productStockQuantity,
          description,
        });
      } else {
        await createExpense({
          amount,
          date: new Date(),
          productId: null,
          productStockQuantity: null,
          description,
          title,
          userId,
        });
      }
      getExpensesMethod();
      onClose();
    } catch (error) {
      console.error("Ha ocurrido un error inesperado", error);
    }
    setLoading(false);
  };

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={expenseData ? "Confirmar cambios" : "Añadir gasto"}
    >
      <div>
        <TextInput
          label="Título"
          value={title}
          onChange={(event) => setTitle(event.currentTarget.value)}
          required
          style={{ marginBottom: "1rem" }}
        />
        <Textarea
          label="Descripción"
          value={description}
          onChange={(event) => setDescription(event.currentTarget.value)}
          required
          style={{ marginBottom: "1rem" }}
        />
        <TextInput
          label="Monto"
          value={amount}
          onChange={(event) => setAmount(event.currentTarget.value)}
          required
          type="number"
          style={{ marginBottom: "1rem" }}
        />
        <Button
          onClick={handleSave}
          loading={loading}
        >
          {expenseData ? "Confirmar cambios" : "Añadir gasto"}
        </Button>
      </div>
    </Modal>
  );
};

export default ExpenseManager;
